import { fetchInventoryRepackages, selectInventoryRepackage, resetCurrentInventoryRepackage } from '../../actions/inventoryRepackages_actions';
import { resetCurrentInventoryConvert } from '../../actions/inventoryConverts_actions';

import { connect } from 'react-redux';

import InventoryRepackages from '../../components/Inventories/inventoryRepackages'

function mapStateToProps(state) {
    return {
        inventoryRepackages: state.inventoryRepackages.all,
        isLoading: state.inventoryRepackages.isLoading,
        error: state.inventoryRepackages.error,
        currentInventoryRepackage: state.inventoryRepackages.currentInventoryRepackage,
        userPermissions: state.auth.userPermissions
    };
}

export default connect(mapStateToProps, { resetCurrentInventoryConvert, fetchInventoryRepackages, selectInventoryRepackage, resetCurrentInventoryRepackage })(InventoryRepackages);



// WEBPACK FOOTER //
// ./master/jsx/containers/Inventories/inventoryRepackages.jsx